import React from 'react';
import Slider from 'react-slick';
import Box from '@mui/material/Box';

const BannerCarousel = ({ images }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000
  };

  return (
    <Slider {...settings}>
      {images.map((src, index) => (
        <Box 
          key={index} 
          sx={{ 
            width: '100%', 
            height: '500px',
            borderRadius: '5px',
            overflow: 'hidden',
            position: 'relative'
          }} 
        >
          <img 
            src={src} 
            alt={`Banner ${index}`} 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'contain',
              position: 'absolute',
              top: 0, 
              left: 0 
            }} 
          />
        </Box>
      ))}
    </Slider>
  );
};

export default BannerCarousel;
